module.exports = fox._r("images/join/li_style.png", __webpack_public_path__ + "images/join/li_style.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/join/li_style.png
// module id = 1065
// module chunks = 4